import * as React from 'react';
import Box from '@mui/material/Box';
import { type GridRenderCellParams, isAutogeneratedRow } from '@mui/x-data-grid-premium';
import type { CountryIsoOption } from '../services/static-data';

interface CountryProps {
  value: CountryIsoOption;
}

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
declare const __DISABLE_CHANCE_RANDOM__: any;
const useStaticFlag = typeof __DISABLE_CHANCE_RANDOM__ !== 'undefined' && __DISABLE_CHANCE_RANDOM__;

const laosFlag = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600">
  <path fill="#ce1126" d="M0 0h900v600H0z" />
  <path fill="#002868" d="M0 150h900v300H0z" />
  <circle r="120" cy="300" cx="450" fill="#fff" />
</svg>
`;

const staticFlagURI = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(laosFlag)}`;

const Country = React.memo(function Country(props: CountryProps) {
  const { value } = props;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        '&  > img': {
          mr: 0.5,
          flexShrink: 0,
          width: '20px',
        },
      }}
    >
      <img
        loading="lazy"
        width="20"
        src={
          useStaticFlag ? staticFlagURI : `https://flagcdn.com/w20/${value.code.toLowerCase()}.png`
        }
        srcSet={
          useStaticFlag ? undefined : `https://flagcdn.com/w40/${value.code.toLowerCase()}.png 2x`
        }
        alt=""
      />

      <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {value.label}
      </Box>
    </Box>
  );
});

export function renderCountry(params: GridRenderCellParams<CountryIsoOption, any, any>) {
  if (params.value == null) {
    return '';
  }

  if (params.aggregation || params.rowNode.type === 'group' || isAutogeneratedRow(params.row)) {
    return params.formattedValue ?? params.value;
  }

  return <Country value={params.value} />;
}
